export { default } from './Promotions';
